/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareLeftIcon16Light = forwardRef('ArrowFigureASquareLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11 7.5a.5.5 0 0 1-.5.5H5.381l1.94 1.616a.5.5 0 0 1-.641.768L4.602 8.652a1.5 1.5 0 0 1 0-2.304L6.68 4.616a.5.5 0 1 1 .64.768L5.381 7H10.5a.5.5 0 0 1 .5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 11a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v7Zm-3 2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7Z" })));
});
